<div *ngIf="businessAvailable" class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> 
                Schedule-4 <br>
                (Particulars of Income from Business)
            </strong>
        </div>
    </div>

    <div class="row my-4 px-2">
        <div class="col-sm-5">
          Name of the Taxpayer: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            TIN:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div class="row mt-5 px-2">
        <div class="col-6">
            <div class="row">
                <div class="col-12">
                    Name of Business: {{returnData?.headSummery?.businessSummeryData?.businessName.join(', ')}}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-12">
                    Nature of Business: {{returnData?.headSummery?.businessSummeryData?.businessCategory.join(', ')}}
                </div>
            </div>
        </div>
    </div>
    <div class="row px-2 mt-3">
        <div class="col-12">
            Address of Business: {{returnData?.headSummery?.businessSummeryData?.businessAddress?.join(', ')}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="5%"><strong> Serial <br> No </strong></td>
                        <td width="65%"><strong> Summary of Income </strong></td>
                        <td width="30%"><strong> Amount in Taka </strong></td>
                    </tr>
                    <tr>
                        <td width="10%">1.</td>
                        <td width="60%">Sales / Turnover / Receipt </td>
                        <td width="30%">{{data?.salesTurnReceipts | currencySeparatorBD}}</td>
                    </tr>
                    <tr>
                        <td width="10%">2.</td>
                        <td width="60%">Gross Profit</td>
                        <td width="30%">{{data?.grossProfit | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">3.</td>
                        <td width="60%">General, Administrative, Selling and Other Expenses</td>
                        <td width="30%">{{data?.gasoExpenses | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">4.</td>
                        <td width="60%">Bad Debt Expense</td>
                        <td width="30%"></td>
                    </tr>
                    <tr>
                        <td width="10%">5.</td>
                        <td width="60%">Net Profit ( 2 – 3)</td>
                        <td width="30%">{{result1 | currencySeparatorBD }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- second table  -->

    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="10%"><strong> Serial <br> No </strong></td>
                        <td width="60%"><strong> Summary of Balance Sheet</strong></td>
                        <td width="30%"><strong> Amount in Taka</strong></td>
                    </tr>
                    <tr>
                        <td width="10%">6.</td>
                        <td width="60%">Cash and Bank Balance </td>
                        <td width="30%">{{data?.cashHandBank | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">7.</td>
                        <td width="60%">Inventory </td>
                        <td width="30%">{{data?.inventories | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">8.</td>
                        <td width="60%">Fixed Assets</td>
                        <td width="30%">{{data?.fixedAssets | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">9.</td>
                        <td width="60%">Other Assets </td>
                        <td width="30%">{{data?.otherAssets | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">10.</td>
                        <td width="60%">Total Assets ( 6 + 7 + 8 + 9)</td>
                        <td width="30%">{{totalAssets | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">11.</td>
                        <td width="60%">Opening Capital </td>
                        <td width="30%">{{data?.openingCp | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">12.</td>
                        <td width="60%">Net Profit </td>
                        <td width="30%">{{data?.netProfit | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">13.</td>
                        <td width="60%">Drawing during the Income Year </td>
                        <td width="30%">{{data?.withdrawalsIncmYr | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">14.</td>
                        <td width="60%">Closing Capital (11 + 12 – 13) </td>
                        <td width="30%">{{closingCapital | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">15.</td>
                        <td width="60%">Liabilities </td>
                        <td width="30%">{{data?.liabilities | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">16.</td>
                        <td width="60%">Total Capital & Liabilities (14 + 15) </td>
                        <td width="30%">{{totalAssetsAndLiabilities | currencySeparatorBD }}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>
